import { Injectable } from "@angular/core";
import { ModalService } from "@app/shared/modal/components/services/modal.service";
import { ErrorModel } from "../models/error-model";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class ErrorHandlerService {
  constructor(private modalService: ModalService, private router: Router) {}

  public showErrorModal(errorMessage: string) {
    this.modalService.open(errorMessage);
  }

  public redirectError(route?: string) {
    this.router.navigate([`/admin/patient`]);
  }

  public handleServerSideError(error: ErrorEvent) {
    this.modalService.open("");
  }
}
